import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
export default (function (evt, parentHTMLElement) {
  if (!parentHTMLElement) {
    return false;
  }

  if (evt.composedPath) {
    return evt.composedPath().includes(parentHTMLElement);
  }

  return parentHTMLElement.contains(evt.target);
});